export default () => ({
  nombre: "",
  token: "",
  email: "",
  foto: "",
})
